// extracted by mini-css-extract-plugin
var _1 = "EntityProfileNavigation-moduleEntityProfileNavigation__KWjEZ";
var _2 = "EntityProfileNavigation-moduleskeleton__NLD98 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "EntityProfileNavigation", _2 as "skeleton" }
